export const registerConfirmDialog = (Alpine) => {
    Alpine.data("confirmDialog", ({ open = false } = {}) => ({
        open,
        init() {
            this.$watch("open", (value) => {
                if (!value) {
                    return;
                }

                this.$nextTick(() => this.$refs.confirmButton?.focus());
            });
        },
        openDialog() {
            this.open = true;
        },
        closeDialog() {
            this.open = false;
        },
        confirm() {
            this.$dispatch("confirmed");
            this.closeDialog();
        },
    }));
};
